export default __webpack_public_path__ + "static/logo-ceoh-nav-561698b8d86fafc609fb2c400109ff76.png";